/* Enord Core classic v1.2 — Video reel classic: lazy-load, play only in view, mouse drag, continuous auto-scroll (pauses on hover/touch). */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root){
    if(root.__erc)return;root.__erc=1;
    var tr=root.querySelector('[data-erc-tr]');if(!tr)return;
    var items=[].slice.call(root.querySelectorAll('[data-erc-it]'));
    var speed=parseFloat(root.getAttribute('data-erc-speed'))||0;
    var step=parseInt(root.getAttribute('data-erc-step'),10)||0;var auto=speed>0&&!reduce&&step<500;
    if(auto)tr.classList.add('is-auto');
    function load(v){if(!v.getAttribute('src')&&v.dataset.src){v.setAttribute('src',v.dataset.src);v.load()}}
    function play(it,v){if(it.__user||reduce)return;load(v);var p=v.play();if(p&&p.catch)p.catch(function(){})}
    function sync(it,v){it.classList.toggle('is-paused',v.paused)}
    items.forEach(function(it){
      var v=it.querySelector('video');if(!v)return;
      ['play','pause','ended'].forEach(function(e){v.addEventListener(e,function(){sync(it,v)})});
      it.querySelector('[data-erc-v]').addEventListener('click',function(){
        if(tr.__moved)return;load(v);
        if(v.paused){it.__user=0;var p=v.play();if(p&&p.catch)p.catch(function(){})}else{it.__user=1;v.pause()}
      });
    });
    if('IntersectionObserver' in window){
      var pre=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){load(e.target.querySelector('video'));pre.unobserve(e.target)}})},{rootMargin:'300px 300px'});
      var vis=new IntersectionObserver(function(es){es.forEach(function(e){var it=e.target,v=it.querySelector('video');if(!v)return;if(e.isIntersecting&&e.intersectionRatio>=.4)play(it,v);else v.pause()})},{threshold:[0,.4,.6]});
      items.forEach(function(it){pre.observe(it);vis.observe(it)});
    }else items.forEach(function(it){var v=it.querySelector('video');if(v){load(v);play(it,v)}});
    // mouse drag
    var down=false,sx=0,sl=0;
    tr.addEventListener('mousedown',function(e){down=true;sx=e.pageX;sl=tr.scrollLeft;tr.__moved=false});
    window.addEventListener('mousemove',function(e){if(!down)return;var d=e.pageX-sx;if(Math.abs(d)>5){tr.__moved=true;tr.classList.add('is-drag')}if(tr.__moved)tr.scrollLeft=sl-d});
    window.addEventListener('mouseup',function(){if(!down)return;down=false;if(tr.__moved){var w=tr.firstElementChild?tr.firstElementChild.offsetWidth:1;tr.classList.remove('is-drag');if(!auto)tr.scrollTo({left:Math.round(tr.scrollLeft/w)*w,behavior:'smooth'});setTimeout(function(){tr.__moved=false},50)}});
    // v1.2 step mode: one video per step, loops (PageFly slideshow autoplay look)
    if(step>=500&&!reduce){
      var sh=false,st=0,sv=true;
      tr.addEventListener('mouseenter',function(){sh=true});tr.addEventListener('mouseleave',function(){sh=false});
      tr.addEventListener('touchstart',function(){sh=true;clearTimeout(st)},{passive:true});
      var sr=function(){clearTimeout(st);st=setTimeout(function(){sh=false},step)};tr.addEventListener('touchend',sr,{passive:true});tr.addEventListener('touchcancel',sr,{passive:true});
      if('IntersectionObserver' in window){new IntersectionObserver(function(es){sv=es[0].isIntersecting},{threshold:0}).observe(root)}
      setInterval(function(){
        if(sh||down||!sv||document.hidden)return;
        var a=tr.children[0],b=tr.children[1];var w=(a&&b)?b.offsetLeft-a.offsetLeft:(a?a.offsetWidth:tr.clientWidth);
        var max=tr.scrollWidth-tr.clientWidth;if(max<=2)return;
        var n=tr.scrollLeft+w;tr.scrollTo({left:n>max+2?0:Math.min(n,max),behavior:'smooth'});
      },step);
    }
    // continuous auto-scroll
    if(auto){
      var hold=false,inView=true,pos=tr.scrollLeft,last=0,touchT=0;
      function hr(){hold=false}
      tr.addEventListener('mouseenter',function(){hold=true});tr.addEventListener('mouseleave',hr);
      tr.addEventListener('touchstart',function(){hold=true;clearTimeout(touchT)},{passive:true});
      var te=function(){clearTimeout(touchT);touchT=setTimeout(hr,1500)};
      tr.addEventListener('touchend',te,{passive:true});tr.addEventListener('touchcancel',te,{passive:true});
      tr.addEventListener('wheel',function(){hold=true;clearTimeout(touchT);touchT=setTimeout(function(){hold=tr.matches(':hover')},800)},{passive:true});
      var tick=function(t){
        requestAnimationFrame(tick);
        var dt=last?Math.min((t-last)/1000,.1):0;last=t;
        if(hold||down||!inView||document.hidden){pos=tr.scrollLeft;return}
        var max=tr.scrollWidth-tr.clientWidth;if(max<=0)return;
        pos+=speed*dt;
        if(pos>=max)pos=0;
        tr.scrollLeft=pos;
      };
      if('IntersectionObserver' in window){new IntersectionObserver(function(es){inView=es[0].isIntersecting;last=0},{threshold:0}).observe(root)}
      requestAnimationFrame(tick);
    }
  }
  function all(){document.querySelectorAll('[data-erc]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();
